$(function () {

    $(window).resize(setIndexScrollHeight);

    function initTripContent(){     
        setParentState();                
        synchContentState();
    }

    function synchContentState() {
        $(".chk-content-section" ).each(function( index ) {              
            var id=$(this).attr('id')
            var bselected= $(this).is(':checked')
            var contentitem= $("#" + id + "-cntidx");
            contentitem.prop('checked', bselected)  ; //reflect change in content - dont think we need to do this if we call synchContentState at the end
            contentitem.removeClass("mixed")
            if ($(this).hasClass("mixed")){contentitem.addClass("mixed");}
        });
    }

    function setParentMix(indexitem) {
        //update parents when mixed
     
        var items= indexitem.closest("li").find("ul .chk-content-section")
        var numChildren= items.length;                
        var numChildrenChecked=items.filter(":checked").length;
   
        indexitem.removeClass("mixed")
        if (numChildrenChecked ==0) {
            indexitem.prop('checked', false);                       
        } else {
            indexitem.prop('checked', true);
            if (numChildrenChecked!=numChildren){  indexitem.addClass("mixed");}
        }
       
    }

     //initialize  mixed state on any checks that have children
    function setParentState(){                               

         //set  mixed state on any checks that have children
         $(".chk-content-section-all").each(function( index ) {
            setParentMix($(this))
        });
    }

    function processContentCheck(indexitem) {
          
        var bselected= indexitem.is(':checked');     
        var rid=getTripDetailRID();
       
        //if item is a parent, check or uncheck all items under it
        var bParent=indexitem.hasClass("chk-content-section-all")
        if(bParent){indexitem.closest("li").find("ul .chk-content-section" ).prop('checked', bselected)}

        //if we have a trip and this place is in the trip, save it
        if (rid!="" && isPlaceInTrip() ){     
           
            var msg=""
            var label=indexitem.next().text()
            if (bselected) {msg= label +  " has been added for " + getTripPlaceName() + " in the trip '" + getTripDetailName() + "'."}          
            else{msg= label +  " has been removed for " + getTripPlaceName() + " in the trip '" + getTripDetailName() + "'."}  
            if (bParent){msg = "All " + msg.replace(" has ", " selections have ");}

             //save the updates
            //Page_Blur(true);
            UpdateReportItem(rid, getTripPlaceId(),  collectItems(),collectPOIItems(),   getTripDetailName(), getTripPlaceName(),getTripPlaceType(),tripPlaceUpdated_callback,msg)

          } else
          {
              setTripDetailDirty();
          }     

        //set the state on any parent check box
         setParentState();
        
        //synch content checkboxes
        synchContentState();
    }

    //index checkbox clicked
    $(".chk-content-section").on('change',function (e){
        processContentCheck ($(this))
    });

    // content checkbox clicked - just reflect state in index and proces as if it's been clicks
    $(".chk-content-section2").on('change',function (e){
        var id=$(this).attr("id");                      
        var idx="#"+id.replace("-cntidx","");
        $(idx).prop("checked",$(this).prop("checked"));
        processContentCheck ($(idx))
    });

    //index checkbox or label clicked- open accoridion section
    $(".content-details-container .checkboxitem .form-check-input,.content-details-container .checkboxitem .form-check-label").on('click',function (e){
       e.stopPropagation();
        
        if ($(this).parents(".accordion-item").length>0){
            $(this).parents(".accordion-item").find(".accordion-collapse").collapse('show');
        }else if ($(this).parents(".not-selectable").length>0){
            $(this).parents(".checkboxitem").click();     
        }

    });

   //index section clicked- scroll to item in content  & open accordion
    $(".content-details-container .checkboxitem,.proposal-toc li").on('click',function (e){

        var href=$(this).data("href");
        if (href!=undefined && href!=""){
            window.location=href;
            e.preventDefault(); 
            return false;
        }
           
        var eleId="#"+$(this).data("scrollto").replace("secttoc","sect");
        var $anchor=$(eleId).offset();           
        
        if ($anchor.top==0){
            //non existent or hidden element --cruise deck
            if (eleId.indexOf("vesseldecks") > -1) {
                //select in dropdown
                $("#selShipDeck").val($(this).data("scrollto"))
                 $("#selShipDeck").trigger('change');
                $anchor=$(eleId).offset();   
            }

        }                                                                                         
          
        var nOffset=65;
        var bClientReport=$(".workspace").hasClass("client-workspace");   

        if (bClientReport){
            nOffset=nOffset+65;
        }

        window.scroll({
              top: $anchor.top-$(".page-header-new").height()-nOffset, 
              left: 0, 
              behavior: 'smooth'
        });       
  
        e.stopPropagation();   //keep the parent frm firing
  
        if ($(this).hasClass("accordion-item")){
            $(this).find(".accordion-collapse").collapse('show');
        }
        
 });

    initTripContent();

    if ($(".guide-content").length>0){
        window.addEventListener('scroll', handleContentIndexScroll);
        setElementPositions();           
    }

})

function selectSection(id){
    $(id).click()
}

function handleContentIndexScroll() {
    var elementsToCheck = document.querySelectorAll('.content_panel_preview');
    if (elementsToCheck.length==0){ elementsToCheck = document.querySelectorAll('.content_panel');}
    var elementsToSet = document.querySelectorAll('.checkboxitem');

    // Find the most in viewport element
    var mostInViewElement = findMostInView(elementsToCheck);

    // Remove the in-view class from all elements
    elementsToSet.forEach(function(element) {
      element.classList.remove('active');
    });

    // Add the in-view class to the most in viewport element
    if (mostInViewElement) {
        var sel="[data-scrollto='" + mostInViewElement.id + "']";
        var x=document.querySelectorAll(sel);
        if (x.length>0){ 
            x[0].classList.add('active');
        }
    }
           
  }

function setIndexScrollHeight(){

        if ($(".fixed-top").length>0){
     
            var header= document.querySelectorAll(".page-header-new")[0].getBoundingClientRect();
            var nHeight=window.innerHeight-header.height-35;       
        
            if ($(".is-preview").length>0){
                  //client preview
                var nWidth=450;
                var padding=5;
                var nLeft=0 ;
                var contentCol =  document.querySelectorAll('.guide-content')[0].getBoundingClientRect();
                               
                if (contentCol.left<nWidth){
                   //screen is too small
                    nLeft =0
                    nWidth  =  contentCol.left -padding;       
                }  else{
                   nLeft= contentCol.left -nWidth -padding; 
                }  
                //console.log('nWidth:'+ nWidth)
                if (nWidth<150){ $(".fixed-top").hide()}else{ $(".fixed-top").show()}
                $(".fixed-top").css('width', nWidth + 'px')
                $(".fixed-top").css('left', nLeft + 'px');

            }   
            else{             
                var header2= document.querySelectorAll(".content-details-container-header")[0].getBoundingClientRect();    
                nHeight=nHeight-header2.height;
                
                var nWidth=450;
                var padding=5;
                var nLeft=0 ;
                var contentCol =  document.querySelectorAll('.guide-content')[0].getBoundingClientRect();
                               
                if (contentCol.left<nWidth){
                   //screen is too small
                    nLeft =0
                    nWidth  =  contentCol.left -padding;       
                }  else{
                   nLeft= contentCol.left -nWidth -padding; 
                }  
                //console.log('nWidth:'+ nWidth)
                if (nWidth<150){ $(".fixed-top:not(.list-search").hide()}else{ $(".fixed-top:not(.list-search").show()}
                $(".fixed-top:not(.list-search").css('width', nWidth + 'px')
               // $(".fixed-top").css('left', nLeft + 'px');

            }   
   
            $(".fixed-top:not(.list-search)").css('height', nHeight + 'px');
            
        }
                                       
        $(".index-preview,.guide-index").show();
  }

function setElementPositions() {
                                         
    var headerHeight =0;

    if ($(".client-report").length>0){
        //client report
        if ($(".page-header-new").length>0){
            var header= document.querySelectorAll(".page-header-new")[0].getBoundingClientRect();
            headerHeight  =header.height;
            $(".content-details-row ").css('top', (headerHeight-60) + 'px');
            $(".fixed-top").css('top', (header.height+20) + 'px');       
        }
       
    }else if ($(".client-report-preview").length>0){
       
        if ($(".content-details-container-header").length>0){
            var header= document.querySelectorAll(".content-details-container-header")[0].getBoundingClientRect();
            headerHeight  =header.height;
            $(".content-details-row").css('top', (headerHeight+10) + 'px');
            $(".content-details-container .fixed-top").css('top', (headerHeight+100) + 'px');   
        }    
    }  else{
   
        if ($(".content-details-container-header").length>0){
            var header= document.querySelectorAll(".content-details-container-header")[0].getBoundingClientRect();
            headerHeight  =header.height;
            $(".content-details-row").css('top', (headerHeight-22) + 'px');
           
            var nTop= headerHeight+100;      //167
            if ($(".fixed-top").hasClass("large-map-visible")){
                console.log("large-map-visible")
                nTop=nTop-37;
                }     
            
            $(".content-details-container .fixed-top").css('top', nTop + 'px');  
        }         
    
    }
 
  

                 
  }

